import { paymentTypeFromOrderForm } from './resolvers/paymentType/fromOrderForm';
import { paymentTypeFromOrderGroup } from './resolvers/paymentType/fromOrderGroup';

/**
 * Selects the appropriate payment_type resolver based on the event name and returns its result.
 *
 * @param context - Runtime context passed to the selected resolver
 * @param eventName - Event identifier that determines which resolver to use
 * @returns The resolved payment_type for the event, or `null` if the event is not recognized
 */
export function getPaymentType(context: Record<string, any>, eventName: string) {
  if (context?.paymentType) return context.paymentType;

  switch (eventName) {
    case 'ORDER_REVIEWED':
    case 'CUSTOM_ADD_PAYMENT_INFO':
      return paymentTypeFromOrderForm(context);
    case 'PURCHASE':
    case 'CUSTOM_PURCHASE':
      return paymentTypeFromOrderGroup(context)
    default:
      return null;
  }
}
